import { render, staticRenderFns } from "./TelstraUIVueSideNav.vue?vue&type=template&id=21661165"
import script from "./TelstraUIVueSideNav.vue.ts?vue&type=script&lang=ts&external"
export * from "./TelstraUIVueSideNav.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports